/*
 * @Author: zhu.huijun
 * @Date: 2021-05-19 14:42:14
 * @Last Modified by: zhu.huijun
 * @Last Modified time: 2021-05-20 10:46:33
 */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { i18n } from 'fishx';
import { PortalCardList, StepFooter } from '@/components';
import styles from './index.module.less';

const getI18n = path => i18n(`SUBS_CARD_LIST_${path}`);
const DefaultData = [
  {
    label: getI18n('LABEL_SERVICE_TYPE'),
    key: 'serviceTypeName',
  },
  {
    label: getI18n('LABEL_PLAN_NAME'),
    key: 'offerName',
  },
  {
    label: getI18n('LABEL_STATUS'),
    key: 'stateName',
  },
];
const SubsCardList = props => {
  const { modelKey, title, searchInfo, qrySubsList, saveSelectSubs, onPrevious, onNext } = props;
  const [subList, setSubList] = useState([]);
  
  const handleDataSave = data => {
    saveSelectSubs({
      modelKey,
      ...data,
    });
  };

  useEffect(() => {
    qrySubsList(searchInfo).then(list => {
      setSubList(list);
      handleDataSave({ subsList: list });
    });
  }, [searchInfo]);

  const handleOfferSelected = value => {
    handleDataSave({ selectedSubs: value });
  };

  const renderCardTitle = data => {
    return (
      <div className={styles.titleBox}>
        <h4>{data.offerName}</h4>
        <span>{data.accNbr}</span>
      </div>
    );
  };
  
  return (
    <>
      <div className={`${styles.subsCardList} blockWrap`}>
        <h3 className="blockTitle">{title || getI18n('TITLE')}</h3>
        <PortalCardList
          cardKey="offerId"
          title={renderCardTitle}
          dataGroup={subList}
          defaultSelect={subList[0]}
          renderItemData={DefaultData}
          onClick={handleOfferSelected}
        />
      </div>
      <StepFooter onPrevious={onPrevious} onContinue={onNext} />
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  qrySubsList: payload =>
    dispatch({
      type: 'search/qrySubsList',
      payload,
    }),
  saveSelectSubs: ({ modelKey, params }) =>
    dispatch({
      type: `${modelKey}/save`,
      payload: params,
    }),
});

export default connect(() => ({}), mapDispatchToProps)(SubsCardList);
